import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ef30fdb"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]

import { onMounted, ref } from 'vue'
import request from '@/utils/request'
import { getAdsList3 } from '@/utils/requestUrl'

interface FloatingIslandAd {
  AdisId: string
  AdsDesc: string
  Image: string
  LinkUrl: string
  Rank: number
  LinkType: string
  ExtensionInfo: string | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FloatingIsland',
  setup(__props) {

const currentIndex = ref(0)
const fixedIconShow = ref(true)
const floatingIslands = ref<FloatingIslandAd[]>([])

const handleFloatingIslandClick = () => {
  if (floatingIslands.value[currentIndex.value]?.LinkUrl) {
    window.open(floatingIslands.value[currentIndex.value].LinkUrl, '_blank')
  }
}

const fetchFloatingIslandData = async () => {
  const data = {
    Data: {
      ShopCode: 'G-Gift',
      ShopHallCode: '',
      PositionType: 'Global-FloatingIsland'
    }
  }

  await request
    .post(
      window._env_.VUE_APP_STOREBOOK_SERVICE_API + getAdsList3,
      data
    )
    .then((res) => {
      const data = res.data.Data
      if (data && data.AdsList) {
        floatingIslands.value = data.AdsList.sort((a: FloatingIslandAd, b: FloatingIslandAd) => a.Rank - b.Rank)

        // 設定輪播
        if (floatingIslands.value.length > 0) {
          setInterval(() => {
            currentIndex.value = (currentIndex.value + 1) % floatingIslands.value.length
          }, 1500)
        }
      }
    })
    .catch((error) => {
      console.error('獲取浮島資料失敗:', error)
    })
}

onMounted(async () => {
  await fetchFloatingIslandData()
})

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (fixedIconShow.value && floatingIslands.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed-icon",
        onClick: handleFloatingIslandClick
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(floatingIslands.value, (img, index) => {
          return (_openBlock(), _createElementBlock("img", {
            key: img.AdsId,
            src: img.Image,
            alt: img.AdsDesc,
            class: _normalizeClass(["absolute w-full object-contain", currentIndex.value === index ? 'opacity-100 z-10' : 'opacity-0 z-0'])
          }, null, 10, _hoisted_1))
        }), 128)),
        _createVNode(_component_Icon, {
          "icon-name": "close_light",
          width: '15px',
          class: "absolute top-[-20px] right-[5px]",
          onClick: _cache[0] || (_cache[0] = (e) => { e.preventDefault(); e.stopPropagation(); fixedIconShow.value = false; })
        })
      ]))
    : _createCommentVNode("", true)
}
}

})